module.exports = __webpack_public_path__ + "img/message-cancel.10fa42eb.png";